import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Check, ChevronRight, Sparkles } from "lucide-react";
import { useCreate } from "@/components/app/AppLayout";
import { api } from "@/lib/api";
import { cn } from "@/lib/utils";

// Own-profile-only completion meter: 5 steps × 20%. Hidden at 100% after a one-time message.
export function ProfileCompletion({ onEdit, refreshKey }) {
  const navigate = useNavigate();
  const openCreate = useCreate();
  const [data, setData] = useState(null);
  const [celebrate, setCelebrate] = useState(false);

  useEffect(() => {
    let on = true;
    api.completion().then((d) => {
      if (!on) return;
      setData(d);
      if (d.pct >= 100 && !d.complete_seen) { setCelebrate(true); api.completionSeen().catch(() => {}); }
    }).catch(() => {});
    return () => { on = false; };
  }, [refreshKey]);

  if (!data) return null;
  if (data.pct >= 100) {
    if (!celebrate) return null;
    return (
      <div data-testid="profile-complete-msg" className="mt-4 flex items-center gap-3 rounded-2xl border border-aura-mint/30 bg-am-surface2 p-3">
        <span className="grid h-9 w-9 place-items-center rounded-xl aura-gradient"><Sparkles className="h-4 w-4 text-black" /></span>
        <div className="flex-1 text-sm font-semibold text-white">Profile complete — your aura is fully set up.</div>
        <button onClick={() => setCelebrate(false)} className="text-xs text-am-text2 hover:text-white">Dismiss</button>
      </div>
    );
  }
  const go = (key) => {
    if (key === "post") return openCreate();
    if (key === "follows") return navigate("/explore");
    onEdit && onEdit(key);
  };
  return (
    <div data-testid="profile-completion" className="mt-4 rounded-2xl border border-am-border bg-am-surface2 p-3.5">
      <div className="flex items-center justify-between">
        <div className="text-sm font-bold text-white">Your profile is {data.pct}% done</div>
        <span className="text-xs text-am-text2">{data.steps.filter((s) => s.done).length}/5</span>
      </div>
      <div className="mt-2 h-2 overflow-hidden rounded-full bg-am-surface3">
        <div className="h-full rounded-full aura-gradient transition-all duration-700" style={{ width: `${data.pct}%` }} data-testid="profile-completion-bar" />
      </div>
      <div className="mt-3 grid gap-1">
        {data.steps.map((s) => (
          <button key={s.key} onClick={() => !s.done && go(s.key)} disabled={s.done} data-testid={`completion-step-${s.key}`}
            className={cn("flex items-center gap-2.5 rounded-xl px-2 py-1.5 text-left text-sm", s.done ? "text-am-text3" : "text-white hover:bg-white/5")}>
            <span className={cn("grid h-5 w-5 place-items-center rounded-full border", s.done ? "border-transparent aura-gradient" : "border-am-border-strong")}>{s.done && <Check className="h-3 w-3 text-black" strokeWidth={3} />}</span>
            <span className={cn("flex-1", s.done && "line-through")}>{s.label}{s.key === "follows" && !s.done ? ` (${s.progress}/3)` : ""}</span>
            {!s.done && <ChevronRight className="h-4 w-4 text-am-text3" />}
          </button>
        ))}
      </div>
    </div>
  );
}
